module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-page', {
    staticClass: "modern-ui",
    attrs: {
      "name": "recommendfriend"
    }
  }, [_c('bc-navbar', {
    attrs: {
      "showLogo": true,
      "logoSrc": _vm.rafLogo
    }
  }), _vm._v(" "), (!_vm.loading) ? [_c('img', {
    staticClass: "raf-img",
    attrs: {
      "src": _vm.headerImageUrl,
      "alt": "raf-image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-container"
  }, [_c('div', {
    staticClass: "avatar"
  }, [_c('img', {
    attrs: {
      "src": _vm.salesPersonImg,
      "alt": "sales person photo"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "name accent-fg"
  }, [_vm._v(_vm._s(_vm.salesPersonName))]), _vm._v(" "), _c('p', {
    staticClass: "position"
  }, [_vm._v(_vm._s(_vm.salesPersonTitle))]), _vm._v(" "), _c('div', {
    staticClass: "title-container"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("Welcome, " + _vm._s(_vm.customerFirstName))]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.subtitleText))])]), _vm._v(" "), (_vm.showTip) ? _c('div', {
    staticClass: "card elevated tip"
  }, [_c('div', {
    staticClass: "tip-header"
  }, [_c('div', {
    staticClass: "tip-title"
  }, [_vm._v("How to refer more?")]), _vm._v(" "), _c('div', {
    staticClass: "badge"
  }, [_vm._v("TIPS AND TRICKS")])]), _vm._v(" "), _c('p', [_vm._v("The easiest referrals come from people who mentioned buying a car recently — even casually. Think about who\n          said that in the last month.")])]) : _vm._e(), _vm._v(" "), (_vm.showStats) ? _c('div', {
    staticClass: "card elevated stats"
  }, [_c('div', {
    staticClass: "stat-item"
  }, [_c('span', {
    staticClass: "stat-value"
  }, [_vm._v(_vm._s(_vm.referred))]), _vm._v(" "), _c('span', {
    staticClass: "stat-label"
  }, [_vm._v("Referred")])]), _vm._v(" "), _c('div', {
    staticClass: "stat-item"
  }, [_c('span', {
    staticClass: "stat-value"
  }, [_vm._v(_vm._s(_vm.purchased))]), _vm._v(" "), _c('span', {
    staticClass: "stat-label"
  }, [_vm._v("Purchased")])]), _vm._v(" "), (_vm.showPendingStats) ? _c('div', {
    staticClass: "stat-item"
  }, [_c('span', {
    staticClass: "stat-value"
  }, [_vm._v(_vm._s(_vm.pending))]), _vm._v(" "), _c('span', {
    staticClass: "stat-label"
  }, [_vm._v("Pending")])]) : _vm._e(), _vm._v(" "), (_vm.showEarnedStats) ? _c('div', {
    staticClass: "stat-item"
  }, [_c('span', {
    staticClass: "stat-value"
  }, [_vm._v(_vm._s(_vm.earned))]), _vm._v(" "), _c('span', {
    staticClass: "stat-label"
  }, [_vm._v("Earned")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showStats) ? _c('f7-link', {
    staticClass: "history-link accent-fg",
    attrs: {
      "href": _vm.referralHistoryUrl
    }
  }, [_vm._v("View History")]) : _vm._e(), _vm._v(" "), (_vm.showMilestone) ? _c('div', {
    staticClass: "card elevated progress"
  }, [_c('div', {
    staticClass: "progress-header"
  }, [_c('p', {
    staticClass: "progress-title"
  }, [_vm._v("Bonus milestone")]), _vm._v(" "), _c('p', {
    staticClass: "progress-stage"
  }, [_vm._v(_vm._s(_vm.purchased) + "/" + _vm._s(_vm.milestoneThreshold))])]), _vm._v(" "), _c('div', {
    staticClass: "progress-wrapper"
  }, [_c('div', {
    staticClass: "progress-container"
  }, [_vm._l((_vm.progressThresholds), function(threshold) {
    return _c('div', {
      key: threshold,
      staticClass: "progress-point",
      class: {
        active: _vm.progressPercentage >= threshold
      }
    }, [(_vm.progressPercentage >= threshold) ? _c('svg', {
      attrs: {
        "width": "12",
        "height": "12",
        "viewBox": "0 0 12 12",
        "fill": "none"
      }
    }, [_c('path', {
      attrs: {
        "d": "M4.10397 9.03563L10.6808 2.24053C10.836 2.08018 11.017 2 11.224 2C11.4309 2 11.612 2.08018 11.7672 2.24053C11.9224 2.40089 12 2.59145 12 2.8122C12 3.03296 11.9224 3.22325 11.7672 3.38307L4.64718 10.7595C4.49198 10.9198 4.31091 11 4.10397 11C3.89703 11 3.71596 10.9198 3.56075 10.7595L0.223853 7.3118C0.0686483 7.15145 -0.00585002 6.96116 0.000358164 6.74094C0.00656635 6.52071 0.0875312 6.33016 0.243253 6.16926C0.398975 6.00837 0.58341 5.9282 0.796558 5.92873C1.00971 5.92926 1.19388 6.00944 1.34909 6.16926L4.10397 9.03563Z",
        "fill": "currentColor"
      }
    })]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "progress-track"
  }), _vm._v(" "), _c('div', {
    staticClass: "progress-bar",
    style: ({
      width: _vm.progressPercentage + '%'
    })
  })], 2), _vm._v(" "), (_vm.progressPercentage === 100) ? _c('img', {
    attrs: {
      "src": require("@/assets/raf/progress-success.png"),
      "alt": "progress success image"
    }
  }) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "progress-description"
  }, [_vm._v(_vm._s(_vm.milestoneDescription))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card info-card"
  }, [(_vm.isNotCompleted) ? _c('div', {
    staticClass: "icon"
  }, [_c(_vm.infoCard.icon, {
    tag: "component"
  })], 1) : _c('img', {
    attrs: {
      "src": require("@/assets/raf/finish.png"),
      "alt": "complete progress image"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.infoCard.title))]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.infoCard.text))])]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('f7-link', {
    staticClass: "mui-button w-100 accent",
    attrs: {
      "href": _vm.addReferralLink
    }
  }, [_vm._v("\n          " + _vm._s(_vm.ctaText) + "\n        ")]), _vm._v(" "), _c('f7-link', {
    staticClass: "mui-button w-100 stroked accent",
    attrs: {
      "href": _vm.whatFriendsSeeUrl
    }
  }, [_c('external-link-icon'), _vm._v("\n          See what friends see\n        ")], 1)], 1)], 1)] : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "skeleton-content"
  }, [_c('div', {
    staticClass: "skeleton raf-img"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-container"
  }, [_c('div', {
    staticClass: "skeleton avatar"
  }), _vm._v(" "), _c('div', {
    staticClass: "skeleton name"
  }), _vm._v(" "), _c('div', {
    staticClass: "skeleton position"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-container"
  }, [_c('h2', {
    staticClass: "skeleton title"
  }), _vm._v(" "), _c('p', {
    staticClass: "skeleton subtitle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "skeleton card stats"
  }), _vm._v(" "), _c('div', {
    staticClass: "skeleton history-link"
  }), _vm._v(" "), _c('div', {
    staticClass: "skeleton card progress"
  }), _vm._v(" "), _c('div', {
    staticClass: "skeleton card info-card"
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "skeleton title"
  }), _vm._v(" "), _c('div', {
    staticClass: "skeleton text"
  })]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "skeleton link mui-button w-100"
  }), _vm._v(" "), _c('div', {
    staticClass: "skeleton link mui-button w-100 stroked"
  })])])]) : _vm._e(), _vm._v(" "), _c('loader', {
    attrs: {
      "show": _vm.loading
    }
  })], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-bcd2cbea", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bcd2cbea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/pages/referral-program/recommend-friend.vue
// module id = 863
// module chunks = 0